import React, { useEffect, useState } from 'react';
import { SidebarNav } from './components/SidebarNav';
import { CoverSection } from './components/CoverSection';
import { IntroSection } from './components/IntroSection';
import { Chapter1 } from './components/Chapter1';
import { Chapter2 } from './components/Chapter2';
import { Chapter3 } from './components/Chapter3';
import { Chapter4 } from './components/Chapter4';
import { Chapter5 } from './components/Chapter5';
import { AnnexSection } from './components/AnnexSection';
import { PricingSection } from './components/PricingSection';
export function App() {
  const [activeSection, setActiveSection] = useState('portada');
  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '-20% 0px -60% 0px',
      threshold: 0
    };
    const observerCallback: IntersectionObserverCallback = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    };
    const observer = new IntersectionObserver(observerCallback, observerOptions);
    const sections = document.querySelectorAll('section[id]');
    sections.forEach(section => observer.observe(section));
    return () => {
      sections.forEach(section => observer.unobserve(section));
    };
  }, []);
  return <div className="flex w-full min-h-screen bg-cream" data-id="element-0">
      <SidebarNav activeSection={activeSection} data-id="element-1" />

      <main className="flex-1 lg:ml-72 w-full overflow-x-hidden" data-id="element-2">
        <CoverSection data-id="element-3" />
        <IntroSection data-id="element-4" />
        <Chapter1 data-id="element-5" />
        <Chapter2 data-id="element-6" />
        <Chapter3 data-id="element-7" />
        <Chapter4 data-id="element-8" />
        <Chapter5 data-id="element-9" />
        <AnnexSection data-id="element-10" />
        <PricingSection data-id="element-11" />
      </main>
    </div>;
}